// POST method implementation to send data to API

// for sending only the JSON data
const postData = async (url = "", data = {}) => {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.json();
};

// GET method implementation to fetch data from API
const getData = async (url = "") => {
  return fetch(url, { method: "GET" })
    .then((response) => response.json())
    .then((responseJson) => {
      return responseJson;
    });
};

// PUT method implementation to send edited/updated data to API
const putData = async (url = "", data = {}) => {
  let result = await fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return result.json();
};

// DELETE method implementation to send deleted instruction to API
const deleteData = async (url = "", data = {}) => {
  let result = await fetch(url, {
    method: "DELETE",
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return result.json();
};

/*------ function for upload single file/image --------*/
const uploadFile = async (url, formValues = {}) => {
  const formData = new FormData();

  formData.append("upload", formValues);

  return fetch(url, {
    method: "post",
    body: formData,
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
};

/*------ function for upload multiple file/image --------*/
const uploadMultipleFile = async (url, formValues = {}) => {
  const formData = new FormData();

  let objArray = Object.keys(formValues);

  objArray.forEach((element) => {
    formData.append("uploads[]", formValues[element]);
  });

  return fetch(url, {
    method: "post",
    body: formData,
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
};

// recomended function for sending form data with file and images ids
const postFormdata = async (url, formValues = {}) => {
  const formData = new FormData();

  let objArray = Object.keys(formValues); // get the keys, i.e form input name

  objArray.forEach((element) => {
    if (Array.isArray(formValues[element])) {
      formData.append(element, JSON.stringify(formValues[element]));
    } else {
      formData.append(element, formValues[element]);
    }
  });

  // declare variable for sending in object
  const config = {
    method: "POST",
    body: formData,
  };

  return fetch(url, config).then((response) => response.json());
};

/*------ optional function for send normal formdata with files -------*/
const postFileFormData = async (url, formValues = {}) => {
  const formData = new FormData();

  let objArray = Object.keys(formValues);

  objArray.forEach((element) => {
    formData.append(element, formValues[element]);
  });

  const config = {
    method: "POST",
    body: formData,
  };

  return fetch(url, config).then((response) => response.json());
};

/*------- This is the method for chat section only --------*/
const postUploadFileData = async (url, formValues = {}) => {
  const formData = new FormData();

  let objArray = Object.keys(formValues); // get the keys, i.e form input name

  objArray.forEach((element) => {
    if (Array.isArray(formValues[element])) {
      let elementArray = Object.keys(formValues[element]);

      elementArray.forEach((item) => {
        // if multile files are sent in as an array, append each file one by one

        formData.append("uploads[]", formValues[element][item]);
      });
    } else {
      formData.append(element, formValues[element]);
    }
  });

  // declare variable for sending in object
  const config = {
    method: "POST",
    body: formData,
  };

  return fetch(url, config).then((response) => response.json());
};

/*------- end of the formdata with file uploader --------*/

export {
  postData,
  getData,
  putData,
  deleteData,
  postFormdata,
  uploadFile,
  uploadMultipleFile,
  postFileFormData,
  postUploadFileData,
};
